module.exports = __webpack_public_path__ + "img/B7.3ad633de.png";